<div
    class="section-padding-vertical-md lg:section-padding-vertical-lg w-full flex flex-wrap justify-center gap-6">
    @if (limitedItems(); as items) {
        @for (item of items; track item) {
            <div class="card !rounded-medium !spacing-sm flex justify-center">
                <img loading="lazy"
                     [src]="item.fields.logo?.fields?.file?.url"
                     class="h-6 object-contain grayscale"
                     alt=""/>
            </div>
        }
    } @else {
        <div class="card !rounded-medium !p-0 flex justify-center animate-pulse overflow-hidden">
            <div class="h-12 w-24 bg-gray-200 rounded"></div>
        </div>

        <div class="card !rounded-medium !p-0 flex justify-center animate-pulse overflow-hidden">
            <div class="h-12 w-24 bg-gray-200 rounded"></div>
        </div>

        <div class="card !rounded-medium !p-0 flex justify-center animate-pulse overflow-hidden">
            <div class="h-12 w-24 bg-gray-200 rounded"></div>
        </div>

        <div class="card !rounded-medium !p-0 flex justify-center animate-pulse overflow-hidden">
            <div class="h-12 w-24 bg-gray-200 rounded"></div>
        </div>
    }
</div>
